import { render, staticRenderFns } from "./CustomHead.vue?vue&type=template&id=e440336e&scoped=true"
import script from "./CustomHead.vue?vue&type=script&lang=js"
export * from "./CustomHead.vue?vue&type=script&lang=js"
import style0 from "./CustomHead.vue?vue&type=style&index=0&id=e440336e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440336e",
  null
  
)

export default component.exports